import type { PerformanceCategories, PerformanceMode } from '@core/constants/types/performance/performance';

/**
 * Derives the master performance mode from a category snapshot.
 *
 * @param categories - Current category values.
 * @returns `'full'` when every category is `true`, otherwise `'performance'`.
 */
const deriveMode = (categories: PerformanceCategories): PerformanceMode => {
  return Object.values(categories).every(Boolean) ? 'full' : 'performance';
}

export default deriveMode;